//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "normalGoods",

  data() {
    return {
      sku: null
    };
  },
  computed: {},
  props: {
    goodInfo: {
      type: Object,
      value: null
    },
    minLadderPrice: {
      type: Object,
      value: null
    },
    goods: {
      type: Object,
      value: null
    },
    isCycle: {
      type: Boolean,
      value: false
    }
  },
  methods: {
    splitFun: function(str, sign, num) {
      if (str != undefined) {
        str = str.toString();
        let arr = str.split(sign);
        if (arr.length > num) {
          return arr[num];
        } else {
          return "00";
        }
      }
      return "";
    },
    strLengthFun: function(str) {
      if (str != undefined) {
        let num = str.length;
        return num;
      }
      return 0;
    }
  },
  created() {}
};



// WEBPACK FOOTER //
// ./src/components/goodDetail/normalGoods.vue